<template>
  <div class="d-flex justify-content-center flex-wrap searchCompContainer">
    <input
      placeholder="Zoek in Google ..."
      class="form-control mt-5"
      id="searchInput"
      v-on:keyup.enter="redirectGoogleSearch"
      v-model="$store.state.searchedString"
    />
    <button
      id="googleSearchbtn"
      class="btn btn-primary h-25 mt-auto mb-0"
      @click="redirectGoogleSearch"
    >
      <i class="fa-light fa-magnifying-glass nl-3"></i>
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    redirectGoogleSearch() {
      // let removeListResults = document.getElementById("___gcse_0");
      // if (removeListResults !== null)
      //   document.body.removeChild(removeListResults);

      let elem = document.createElement("script");
      elem.src = "https://cse.google.com/cse.js?cx=d0bfe3afc3b6e489b";

      let elemToRemove;
      let scriptElems = document.getElementsByTagName("script");
      for (let item of scriptElems) {
        if (item.src === "https://cse.google.com/cse.js?cx=d0bfe3afc3b6e489b") {
          elemToRemove = item;
        }
      }

      setTimeout(() => {
        if (elemToRemove !== undefined) {
          document.body.removeChild(elemToRemove);
        }
      }, 1000);

      document.body.appendChild(elem);
      // this.$router.replace(
      //   this.$store.state.routing.homePage +
      //     `?q=${this.$store.state.searchedString}`
      // );
      window.open(
        this.$store.state.routing.homePage +
          `?q=${this.$store.state.searchedString}`,
        "_self"
      );
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
#searchInput {
  width: 360px;
  height: 42px;
  border-radius: 15px;
  margin-right: -50px;
  box-shadow: none;
}

#googleSearchbtn {
  border-radius: 15px;
  width: 50px;
  height: 43px !important;
  position: relative;
}

@media only screen and (max-width: 1200px) {
  #searchInput {
    width: 100%;
    flex-wrap: nowrap;
  }
  .searchCompContainer {
    width: 100%;
  }
}
/* @media only screen and (max-width: 992px) {
  .searchCompContainer,
  input#searchInput {
    width: 100% !important;
    font-size: 16px;
  }
} */
</style>